import React, { Fragment, memo, useContext, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { openDashboardDialog } from '@actions/dashboard-actions';
import { createNewSegment } from '@actions/data-detail-actions';

import ParamsContext from '@components/entity/info/params-context';

import * as dialog from '@constants/dialogs';
import { detailEdit } from '@constants/mui-theme';

import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui';
import DescriptionIcon from '@mui/icons-material/Description';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

import { getIsSegmentsRequired } from '@components/config/selectors';
import { useEntityTypeScheduleEnabled } from '@components/config/hooks';
import { pluralize } from '@utils/shared-utils';
import UnstyledHeading from '@shared/unstyled-heading';

import '../../../../../forms/forms.scss';

const SegmentTitle = ({ readOnly, tab }) => {
  const dispatch = useDispatch();
  const { dataType, publicConfig = false } = useContext(ParamsContext);
  const { data } = useSelector(state => state.dataDetail);

  const segments = useMemo(() => data?.segments || [], [data?.segments]);

  const onAdd = () => dispatch(createNewSegment());

  const onBulk = () => dispatch(openDashboardDialog(dialog.BULK_SCHEDULE, { data }));

  const onView = () => dispatch(openDashboardDialog(dialog.VIEW_SCHEDULE, { data, dataType }));
  const segmentsRequired = useSelector(state => getIsSegmentsRequired(state, dataType, publicConfig));

  const segmentCount = segments ? segments.length : 0;
  const showError = segmentCount === 0 && segmentsRequired;
  const extraStyle = `form-title-label-extra ${showError ? 'form-title-label-extra-error' : ''}`;
  const scheduleEnabled = useEntityTypeScheduleEnabled(dataType, publicConfig);

  return (
    <div styleName="form-title" id={`tab-section-${tab.id}-title`}>
      <div styleName="form-title-counter">
        {segmentCount}
      </div>
      <UnstyledHeading rank={3} routeFocusSkip styleName="form-title-label">
        {pluralize(segmentCount, tab.label)}
      </UnstyledHeading>
      <div styleName="form-title-copy">
        {scheduleEnabled && segmentCount > 0 && (
          <IconButton onClick={onView} style={{ padding: 0 }} aria-label="View schedule">
            <DescriptionIcon {...detailEdit.segmentEdit.openScheduleButton} />
          </IconButton>
        )}
      </div>
      {tab.extra && (
        <div styleName={extraStyle}>
          {tab.extra}
        </div>
      )}
      <div styleName="form-title-filler" />
      {!readOnly &&
        <Fragment>
          {scheduleEnabled && segmentCount > 0 && (
            <IconButton onClick={onBulk} style={{ padding: 0, marginRight: '1.5rem' }} aria-label="Bulk schedule">
              <MoreTimeIcon />
            </IconButton>
          )}
          <IconButton onClick={onAdd} style={{ padding: 0 }} aria-label="add location">
            <AddIcon />
          </IconButton>
        </Fragment>
      }
    </div>
  );
};

SegmentTitle.propTypes = {
  readOnly: PropTypes.bool,
  tab: PropTypes.object
};

export default memo(SegmentTitle);
